import { getEnv } from "app/env";

export default {
  token: getEnv("APP_ENV") === "production" ? getEnv("WOOTRIC_TOKEN") : "",
};
